<template>
  <div class="detail-lightbox">
    <div class="detail-lightbox__banner">
      <div v-if="imgLoaded" class="detail-lightbox__banner__action">
        <div class="detail-lightbox__banner__action__save">
          <button class="btn-regular secondary" @click="save">
           <i class="adx-ic_plus"></i>
           <span>Save</span>
          </button>
        </div>
        <div class="detail-lightbox__banner__action__viewphoto">
          <button class="btn-regular secondary" @click="toggle">
            View Photos
          </button>
        </div>
      </div>
      <div v-else class="detail-lightbox__banner__noaction">
        <div class="detail-lightbox__banner__noaction__viewphoto">
          <button class="btn-regular secondary" @click="toggle">
            View Photos
          </button>
        </div>
      </div>
      <adx-detail-slider :class="isPhotosAvailable ? 'detail-lightbox__banner__img' : 'detail-lightbox__banner__placeholder'"
      :slide="1" :isDetail="true" :isCenterMobile="false" :arrowMobile="false" :data="isPhotosAvailable ? detailSlider : placeholderImage" />
    </div>
    <div v-if="!infoLoaded" class="loading-container">
      <adx-loading />
    </div>
    <!-- left detail content -->
    <div v-else class="detail-lightbox__info">
      <div class="detail-lightbox__info__left">
        <div class="detail-lightbox__info__left__header">
          <adx-label-custom :color="'#c283fa'" :label="'Airlines'"/>
          <h2 class="large-title title">{{lightbox.title}}</h2>
          <span class="detail-lightbox__info__left__header--placement subhead">{{channel_type}} . {{lightbox.placement}}</span>
        </div>
        <div class="detail-lightbox__info__left__media-package">
          <div class="detail-lightbox__info__left__media-package__title">
            <h2 class="regular-font">Media Package</h2>
          </div>
          <div class="detail-lightbox__info__left__media-package__content">
            <p class="subhead">{{lightbox.description}}</p>
          </div>
        </div>
        <!-- <div class="detail-lightbox__info__left__media"> -->
          <!-- <div class="detail-lightbox__info__left__media__title">
            <h2 class="regular-font">Media Details</h2>
          </div> -->
          <!-- <div v-if="media.size" class="detail-lightbox__info__left__media__content">
            <div class="detail-lightbox__info__left__media__content--item" >
              <span>Size <strong>{{ media.size }} {{media.measurement_unit}}</strong></span>
            </div>
            <div v-if="media.material" class="detail-lightbox__info__left__media__content--item">
              <span>Material <strong>{{ media.material }}</strong></span>
            </div>
            <div v-if="media.min_order" class="detail-lightbox__info__left__media__content--item">
              <span>Minimum Order <strong>{{ media.min_order }} Month</strong></span>
            </div>
            <div v-if="media.total_spot" class="detail-lightbox__info__left__media__content--item">
              <span>Total Spot <strong>{{ media.total_spot }}</strong></span>
            </div>
            <div v-if="lightbox.placement" class="detail-lightbox__info__left__media__content--item">
              <span>Placement <strong>{{ lightbox.placement }}</strong></span>
            </div>
          </div>
        </div> -->
        <div class="detail-lightbox__info__left__about">
          <div class="detail-lightbox__info__left__about__title">
            <h2 class="regular-font">About Location</h2>
          </div>
          <div class="detail-lightbox__info__left__about__content">
            <p class="subhead">{{lightbox.locDesc}}</p>
          </div>
        </div>
        <div class="detail-lightbox__info__left__operatinghour">
          <div class="detail-lightbox__info__left__operatinghour__title">
            <h2 class="regular-font">Operation Hours</h2>
          </div>
          <div class="detail-lightbox__info__left__operatinghour__content">
            <div class="detail-lightbox__info__left__operatinghour__content--item" v-for="(operatinghour, index) in OperatingHours" :key="index">
              <span class="days">{{operatinghour.day}}</span>
              <span :class="['times', operatinghour.isOpen ? '' : 'day-close', 'subhead']">{{operatinghour.time}}</span>
            </div>
          </div>
        </div>
        <div v-if="lightbox.surrounding" class="detail-lightbox__info__left__surrounding">
          <div class="detail-lightbox__info__left__surrounding__title">
            <h2 class="regular-font">Surrounding</h2>
          </div>
          <div class="detail-lightbox__info__left__surrounding__content">
            <p class="subhead">{{ lightbox.surrounding }}</p>
          </div>
        </div>
        <div class="detail-lightbox__info__left__traffic">
          <div class="detail-lightbox__info__left__traffic__title">
            <h2 class="regular-font">Traffic</h2>
          </div>
          <div v-if="traffic.visitor" class="detail-lightbox__info__left__traffic__content">
            <span>Monthly Traffic : {{ traffic.visitor }} Visitors</span>
          </div>
          <div v-if="traffic.spending" class="detail-lightbox__info__left__traffic__content">
            <i class="adx-ic_cards"></i>
            <span class="item">Average Spending  {{traffic.spending | formatMoney}} /person/visit</span>
          </div>
          <div v-if="traffic.occupation" class="detail-lightbox__info__left__traffic__content">
            <i class="adx-ic_briefcase"></i>
            <span class="item">{{traffic.occupation}}</span>
          </div>
          <div v-if="traffic.visitor_profile" class="detail-lightbox__info__left__traffic__content">
            <i class="icon-knowledge-base"></i>
            <span class="item">{{traffic.visitor_profile}}</span>
          </div> 
        </div>
      </div>
      <!-- right detail content -->
      <div class="detail-lightbox__info__right">
        <div class="detail-lightbox__info__right__price">
          <h4 class="subhead title">Price per month</h4>
          <h3 class="medium-title price">{{lightbox.price|formatMoney}}</h3>
        </div>
        <div class="detail-lightbox__info__right__forbidden">
          <div class="detail-lightbox__info__right__forbidden--title">
            <i class="icon-warning"></i>
            <h3>Terms & Condition</h3>
          </div>
          <div class="detail-lightbox__info__right__forbidden--content">
            <p>{{lightbox.forbidden}}</p>
          </div>
        </div>
        <div class="detail-lightbox__info__right__address">
          <div class="detail-lightbox__info__right__address--title">
            <i class="icon-pin"></i>
            <h3>Address</h3>
          </div>
          <div class="detail-lightbox__info__right__address--content">
            <p>{{lightbox.address}}</p>
          </div>
        </div>
        <div class="detail-lightbox__info__right__action">
          <button class="btn-large primary add" @click="showCampaign">Add to Campaign</button>
        </div>
      </div>
    </div>
    <div v-if="infoLoaded" class="detail-lightbox__footer">
      <div class="detail-lightbox__footer__left">
        <p class="micro-font title">Price per month</p>
        <p class="medium-title price">{{lightbox.price|formatMoney}}</p>
      </div>
      <div class="detail-lightbox__footer__right">
        <button class="btn-large btn-block primary" @click="showCampaign">Add to Campaign</button>
      </div>
    </div>
    <adx-modal v-if="isOpen" @modal-close="toggle" :type="`full`" :color="`transparant`">
      <div slot="content" class="content">
        <adx-detail-slider :isImageShow="true" :slide="1" :arrowMobile="true" @current="getCurrent" @init="getCount" :data="detailSlider" />
        <div class="modal__wrapper__footer">
          <span class="left">Image {{currentSlide}} of {{countSlide}} </span> <span class="right"> - {{lightbox.title}}</span>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
  import DetailSlider from '@/components/Slider/DetailSlider'
  import Modal from '@/components/Modal'
  import LoadingSecondary from '@/components/Loading/Secondary'
  import LoadingSpin from '@/components/Loading/Secondary-white'
  import LoadingPrimary from '@/components/Loading/Primary'
  import LabelStatus from '@/components/StatusLabel'
  import CategoryJumbotron from '@/components/Jumbotron/Category'
  import LabelStatusCustom from '@/components/StatusLabelCustom'
  import api from '@/api'
  import { apiV2 } from '@/api/urls'
  import { airlinesParams } from '@/api/params'
  import { formatNumber } from '@/lib/filter'
  import { mapGetters, mapActions, mapMutations } from 'vuex'

  export default {
    name: 'adx-am_lightbox',
    components: {
      'adx-detail-slider': DetailSlider,
      'adx-modal': Modal,
      'adx-loading-circle': LoadingSecondary,
      'adx-loading-spin': LoadingSpin,
      'adx-loading': LoadingPrimary,
      'label-status': LabelStatus,
      'category-jumbotron': CategoryJumbotron,
      'adx-label-custom': LabelStatusCustom
    },
    props: {

    },
    data() {
      return {
        channel_type:'Lightbox',
        isLoadingCampaign: true,
        isLoadingAppend: [],
        isCreateCampaign: false,
        isMobile: window.innerWidth < 769,
        isShownCampaign: false,
        campaigns: [],
        category: 'lifestyle',
        lightbox: {
          title: ``,
          placement: ``,
          locDesc: ``,
          type: ``,
          price: ``,
          dailyVisitor: ``,
          address: ``,
          description: ``,
          playback: ``,
          forbidden: ``,
          surrounding: '',
        },
        media: {
          size: null,
          material: null,
          measurement_unit: null,
          total_spot: null,
        },
        traffic:{
          visitor: null,
          spending: null,
          occupation: null,
          visitor_profile: null,
        },
        detailSlider: [],
        OperatingHours: [],
        isOpen: false,
        currentSlide: 1,
        countSlide: null,
        pub_id: null,
        imgLoaded: false,
        infoLoaded: false,
        savedLoading: false,
        params: null,
        placeholderImage:[{
          id: 0,
          url: `/img/notfound/img-placeholder_landscape.jpg`,
          thumbnail : `/img/notfound/img-placeholder_landscape.jpg`,
          is_primary: false,
          caption: 'placeholder'
        }],
      }
    },
    computed: {
      ...mapGetters ({
        defaultSaved: 'default',
        token: 'token'
      }),
      isPhotosAvailable(){
        return this.detailSlider.length > 0
      },
    },
    watch: {

    },
    beforeCreate() {

    },
    created() {

    },
    beforeMount() {
      const { pub_id } = this.$route.params
      this.pub_id = pub_id
      const categoryName = this.$options.name.split(`-`).pop()
      this.params = { ...airlinesParams[categoryName]}

      this.loadData()
      this.loadImage()
    },
    mounted() {

    },
    beforeUpdate() {

    },
    updated() {

    },
    activated() {

    },
    deactivated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      showCampaign(){
        
      },
      loadData () {
        (async () => {
          const { data } = await api.get(apiV2.airlinesDetail(this.pub_id), { params: this.params , needToken: true })
          this.mapData(data)
          this.infoLoaded = true
        })();
      },
      loadImage () {
        (async () => {
          this.detailSlider = []
          const { data } = await api.get(apiV2.airlinesDetailImage(this.pub_id), { params: this.params , needToken: true })
          let isPrimaryExist = false
          let image = []
          data.map(el => {
            if(el.is_primary){
              isPrimaryExist = true
              image.push({
                id: el.id,
                url: el.image,
                thumbnail : el.thumbnail_720,
                is_primary: el.is_primary,
                caption: el.caption
              })
            }
          })
          this.imgLoaded = true
          if (!isPrimaryExist && data.length > 0){
            let firstPic = data[0]
            this.detailSlider.push({
              id: firstPic.id,
              url: firstPic.image,
              thumbnail : firstPic.thumbnail_720,
              is_primary: firstPic.is_primary,
              caption: firstPic.caption
            })
          } else if (image.length > 0) {
            this.detailSlider.push(image[0])
          }
        })();
      },
      mapData (data) {
        this.lightbox = {
          title: data.title,
          placement: data.placement,
          locDesc: data.location_inside.about,
          price: data.price,
          address: (data.location_inside.street ? data.location_inside.street : 'N/A'),
          description: data.description,
          forbidden: (data.forbidden_ads ? data.forbidden_ads : 'There\'s no forbidden ads'),
          surrounding: data.surround.name,
        }
        let purchaseResc = '-'
        if (data.purchase_restriction){
          purchaseResc = data.purchase_restriction.min_quantity + ' ' + data.purchase_restriction.min_period_type 
        }
        this.media = {
          min_order: purchaseResc,
          size: data.size + data.measurement_unit,
          material: data.material,
          min_order: data.quantity,
          total_spot: data.slot,
          placement: data.placement,
          total_spot: data.quantity,
        }
        this.traffic = {
          visitor: data.location_inside.traffic,
          spending: (data.location_inside.spending_average ? data.location_inside.spending_average : 0),
          occupation: ` Occupation ${data.profile.job.join(` `)}`,
          visitor_profile: ` Visitor Profile ${data.profile.ses.join(` `)}`,
        }
        this.OperatingHours = data.operating_hours.map(el => {
          let data = {}
          data.day = el.day
          data.isOpen = el.is_open
          if (el.is_open) {
            data.time = `${el.start} - ${el.end}`
          } else {
            data.time = 'closed'
          }
          return data
        })
      },
      save(){

      },
      toggle() {
        this.isOpen = !this.isOpen
      },
      getCurrent(item) {
        this.currentSlide = item + 1
      },
      getCount(item) {
        this.countSlide = item
      }
    }
  }
</script>

<style lang="scss" scoped>
@import 'index';
@import '~@/styles/variables';
@import '~@/styles/mixins';
.uppercase{
  text-transform: uppercase;
}
</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.detail-lightbox__banner__placeholder {
  .slick-slide {
    img.detail {
      object-fit: unset;
    }
  }
}

@include breakpoint(md) {
  .detail-lightbox__banner__img {
    .slick-slide {
      img.detail {
        height: 260px;
      }
    }
  }
  .detail-lightbox__banner__placeholder {
    .slick-slide {
      img.detail {
        height: 260px;
      }
    }
  }
}
</style>
